import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { BasePermission, Organization, PortfolioPlanId, TransformerId, } from "../../Types";
import { stringifyQueryParams } from "../../utils/stringifyQueryParams";
import ValidationError from "../../ZodError";
import { Entry, PersonId } from "../types";
export const url = (queryString) => {
    const qs = stringifyQueryParams(queryString);
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/investment/portfolio-plans:batchCreate?${qs}`
        : `https://middleware.uat.farther.com/investment/portfolio-plans:batchCreate?${qs}`;
};
const BatchValidationError = z.object({
    message: z.string(),
    details: z.string().array(),
});
const BatchCreate = z
    .object({
    portfolioPlanId: PortfolioPlanId,
    ownerId: PersonId,
    organization: Organization,
    name: z.string(),
    tags: z.enum(["DirectIndexedSleeve", "Taxable", "TaxExempt"]).array(),
    entries: Entry.array(),
    transformers: z
        .object({ transformerId: TransformerId, metadata: z.unknown() })
        .array(),
    basePermission: BasePermission,
    portfolioFamilyPath: z.string().optional(),
})
    .array();
const Response = z.object({
    data: BatchCreate,
});
export const postPortfoliosPlansBatch = async ({ data, dryRun }, config) => {
    let bodyToSend;
    if (data instanceof File) {
        const formData = new FormData();
        formData.set("csv", data);
        bodyToSend = formData;
    }
    else {
        bodyToSend = { plans: data };
    }
    const resp = await axios.post(url({ dryRun }), bodyToSend, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
            version: "20241030",
            "Idempotency-key": `PortfolioPlans:batchCreate:id${Date.now()}`,
            ...(data instanceof File && { "Content-Type": "multipart/form-data" }),
        },
        validateStatus: () => true,
    });
    if (resp.status === 400) {
        const decoded = BatchValidationError.safeParse(resp.data);
        if (decoded.success) {
            return { success: false, error: decoded.data };
        }
    }
    if (resp.status !== 200) {
        const errorMessage = `[postPortfoliosPlansBatch] returned unexpected status code: ${resp.status}`;
        throw new Error(errorMessage);
    }
    const decoded = Response.safeParse(resp.data);
    if (decoded.success) {
        return { success: true, data: decoded.data.data };
    }
    else {
        const errorMessage = "[postPortfoliosPlansBatch] returned unexpected data.";
        errorLog(postPortfoliosPlansBatch.name, JSON.stringify(decoded.error.issues));
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
};
//# sourceMappingURL=postPortfolioPlansBatch.js.map